"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireAssessorFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireAssessorFactory = /** @class */ (function (_super) {
    __extends(SapphireAssessorFactory, _super);
    function SapphireAssessorFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireAssessorFactory.prototype.deploy = function (_mapper, _passportScores, _maxScore, overrides) {
        return _super.prototype.deploy.call(this, _mapper, _passportScores, _maxScore, overrides || {});
    };
    SapphireAssessorFactory.prototype.getDeployTransaction = function (_mapper, _passportScores, _maxScore, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _mapper, _passportScores, _maxScore, overrides || {});
    };
    SapphireAssessorFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireAssessorFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireAssessorFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireAssessorFactory;
}(contracts_1.ContractFactory));
exports.SapphireAssessorFactory = SapphireAssessorFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mapper",
                type: "address",
            },
            {
                internalType: "address",
                name: "_passportScores",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_maxScore",
                type: "uint16",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newMapper",
                type: "address",
            },
        ],
        name: "MapperSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint16",
                name: "_maxScore",
                type: "uint16",
            },
        ],
        name: "MaxScoreSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newCreditScoreContract",
                type: "address",
            },
        ],
        name: "PassportScoreContractSet",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lowerBound",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_upperBound",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "_isScoreRequired",
                type: "bool",
            },
        ],
        name: "assess",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_borrowAmount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_borrowLimitProof",
                type: "tuple",
            },
        ],
        name: "assessBorrowLimit",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPassportScoresContract",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mapper",
        outputs: [
            {
                internalType: "contract ISapphireMapper",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxScore",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "passportScoresContract",
        outputs: [
            {
                internalType: "contract ISapphirePassportScores",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_mapper",
                type: "address",
            },
        ],
        name: "setMapper",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "_maxScore",
                type: "uint16",
            },
        ],
        name: "setMaxScore",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_creditScore",
                type: "address",
            },
        ],
        name: "setPassportScoreContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60806040523480156200001157600080fd5b50604051620012c7380380620012c78339810160408190526200003491620002c1565b600080546001600160a01b0319163390811782556040519091907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a362000092836001600160a01b03166200018360201b62000baf1760201c565b8015620000b95750620000b9826001600160a01b03166200018360201b62000baf1760201c565b6200013f5760405162461bcd60e51b8152602060048201526044602482018190527f53617070686972654173736573736f723a206d617070657220616e6420706173908201527f73706f72742073636f726573206d7573742062652076616c696420636f6e74726064820152636163747360e01b608482015260a4015b60405180910390fd5b600280546001600160a01b038086166001600160a01b03199283161790925560018054928516929091169190911790556200017a8162000189565b50505062000313565b3b151590565b6000546001600160a01b03163314620001e55760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640162000136565b60008161ffff16116200024e5760405162461bcd60e51b815260206004820152602a60248201527f53617070686972654173736573736f723a206d61782073636f72652063616e6e6044820152696f74206265207a65726f60b01b606482015260840162000136565b6002805461ffff60a01b1916600160a01b61ffff8416908102919091179091556040519081527f3f5b32a462aea0dad4bc831d7b5d8761b4a8c94a2fe0fa8c544e3984e31071d09060200160405180910390a150565b80516001600160a01b0381168114620002bc57600080fd5b919050565b600080600060608486031215620002d6578283fd5b620002e184620002a4565b9250620002f160208501620002a4565b9150604084015161ffff8116811462000308578182fd5b809150509250925092565b610fa480620003236000396000f3fe608060405234801561001057600080fd5b50600436106100b45760003560e01c80639653325a116100715780639653325a1461014b5780639a1b4b381461015c5780639e36339d14610184578063c38a960e146101a7578063c51da9a9146101ba578063f2fde38b146101cd57600080fd5b80630a6a49bd146100b95780630b9462c2146100ce57806362f4f6a2146100e157806369b67d4414610111578063715018a6146101325780638da5cb5b1461013a575b600080fd5b6100cc6100c7366004610cea565b6101e0565b005b6100cc6100dc366004610cad565b6102d1565b6002546100f4906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b61012461011f366004610d6f565b61043d565b604051908152602001610108565b6100cc610770565b6000546001600160a01b03166100f4565b6001546001600160a01b03166100f4565b60025461017190600160a01b900461ffff1681565b60405161ffff9091168152602001610108565b610197610192366004610d24565b6107f6565b6040519015158152602001610108565b6100cc6101b5366004610cad565b61096b565b6001546100f4906001600160a01b031681565b6100cc6101db366004610cad565b610ac5565b6000546001600160a01b031633146102135760405162461bcd60e51b815260040161020a90610e2d565b60405180910390fd5b60008161ffff161161027a5760405162461bcd60e51b815260206004820152602a60248201527f53617070686972654173736573736f723a206d61782073636f72652063616e6e6044820152696f74206265207a65726f60b01b606482015260840161020a565b6002805461ffff60a01b1916600160a01b61ffff8416908102919091179091556040519081527f3f5b32a462aea0dad4bc831d7b5d8761b4a8c94a2fe0fa8c544e3984e31071d0906020015b60405180910390a150565b6000546001600160a01b031633146102fb5760405162461bcd60e51b815260040161020a90610e2d565b6001600160a01b0381163b61036b5760405162461bcd60e51b815260206004820152603060248201527f53617070686972654173736573736f723a205f63726564697453636f7265206960448201526f1cc81b9bdd08184818dbdb9d1c9858dd60821b606482015260840161020a565b6001546001600160a01b03828116911614156103ef5760405162461bcd60e51b815260206004820152603f60248201527f53617070686972654173736573736f723a205468652073616d6520637265646960448201527f742073636f726520636f6e747261637420697320616c72656164792073657400606482015260840161020a565b600180546001600160a01b0319166001600160a01b0383169081179091556040519081527faa461a0a7f31fa63140c7e21252471c7e80e6389d5dbfba60493a83ef5c54217906020016102c6565b81516000908390839083906001600160a01b03161580159061045c5750805b1561048a5782516001600160a01b0316331461048a5760405162461bcd60e51b815260040161020a90610dd0565b6060830151511515828061049b5750805b806104aa575060008460400151115b156105315760015460405163b56518a960e01b81526001600160a01b039091169063b56518a9906104df908790600401610e62565b60206040518083038186803b1580156104f757600080fd5b505afa15801561050b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061052f9190610cce565b505b6000881161059a5760405162461bcd60e51b815260206004820152603060248201527f53617070686972654173736573736f723a2054686520757070657220626f756e60448201526f642063616e6e6f74206265207a65726f60801b606482015260840161020a565b87891061061e5760405162461bcd60e51b815260206004820152604660248201527f53617070686972654173736573736f723a20546865206c6f77657220626f756e60448201527f64206d75737420626520736d616c6c6572207468616e2074686520757070657260648201526508189bdd5b9960d21b608482015260a40161020a565b606087015151600254901515906000906001600160a01b0316638a60d2e18361064857600061064e565b8a604001515b60025460405160e084901b6001600160e01b03191681526004810192909252600160a01b900461ffff166024820152604481018e9052606481018d905260840160206040518083038186803b1580156106a657600080fd5b505afa1580156106ba573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106de9190610d0c565b90508a81101580156106f05750898111155b6107625760405162461bcd60e51b815260206004820152603b60248201527f53617070686972654173736573736f723a20546865206d61707065722072657460448201527f75726e656420612076616c7565206f7574206f6620626f756e64730000000000606482015260840161020a565b9a9950505050505050505050565b6000546001600160a01b0316331461079a5760405162461bcd60e51b815260040161020a90610e2d565b60405162461bcd60e51b815260206004820152602b60248201527f53617070686972654173736573736f723a2063616e6e6f742072656e6f756e6360448201526a065206f776e6572736869760ac1b606482015260840161020a565b600061080182610f35565b80516001906000906001600160a01b03161580159061081d5750805b1561084b5782516001600160a01b0316331461084b5760405162461bcd60e51b815260040161020a90610dd0565b6060830151511515828061085c5750805b8061086b575060008460400151115b156108f25760015460405163b56518a960e01b81526001600160a01b039091169063b56518a9906108a0908790600401610e62565b60206040518083038186803b1580156108b857600080fd5b505afa1580156108cc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108f09190610cce565b505b6000871161095d5760405162461bcd60e51b815260206004820152603260248201527f53617070686972654173736573736f723a2054686520626f72726f7720616d6f604482015271756e742063616e6e6f74206265207a65726f60701b606482015260840161020a565b505050505060400135101590565b6000546001600160a01b031633146109955760405162461bcd60e51b815260040161020a90610e2d565b6001600160a01b0381163b610a005760405162461bcd60e51b815260206004820152602b60248201527f53617070686972654173736573736f723a205f6d6170706572206973206e6f7460448201526a08184818dbdb9d1c9858dd60aa1b606482015260840161020a565b6002546001600160a01b0382811691161415610a775760405162461bcd60e51b815260206004820152603060248201527f53617070686972654173736573736f723a205468652073616d65206d6170706560448201526f1c881a5cc8185b1c9958591e481cd95d60821b606482015260840161020a565b600280546001600160a01b0319166001600160a01b0383169081179091556040519081527fc5d11f6598061f47a5c6ef9053ad634367b77f8449bc498b80a11c7a64d8dd2c906020016102c6565b6000546001600160a01b03163314610aef5760405162461bcd60e51b815260040161020a90610e2d565b6001600160a01b038116610b545760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161020a565b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b0319166001600160a01b0392909216919091179055565b3b151590565b80356001600160a01b0381168114610bcc57600080fd5b919050565b600060808284031215610be2578081fd5b610bea610edb565b9050610bf582610bb5565b81526020808301358183015260408301356040830152606083013567ffffffffffffffff80821115610c2657600080fd5b818501915085601f830112610c3a57600080fd5b813581811115610c4c57610c4c610f47565b8060051b9150610c5d848301610f04565b8181528481019084860184860187018a1015610c7857600080fd5b600095505b83861015610c9b578035835260019590950194918601918601610c7d565b50606087015250939695505050505050565b600060208284031215610cbe578081fd5b610cc782610bb5565b9392505050565b600060208284031215610cdf578081fd5b8151610cc781610f5d565b600060208284031215610cfb578081fd5b813561ffff81168114610cc7578182fd5b600060208284031215610d1d578081fd5b5051919050565b60008060408385031215610d36578081fd5b82359150602083013567ffffffffffffffff811115610d53578182fd5b830160808186031215610d64578182fd5b809150509250929050565b60008060008060808587031215610d84578182fd5b8435935060208501359250604085013567ffffffffffffffff811115610da8578283fd5b610db487828801610bd1565b9250506060850135610dc581610f5d565b939692955090935050565b6020808252603c908201527f50617373706f727453636f726556657269666961626c653a2070726f6f66206460408201527f6f6573206e6f742062656c6f6e6720746f207468652063616c6c657200000000606082015260800190565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b602080825282516001600160a01b03168282015282810151604080840191909152830151606080840191909152830151608080840152805160a0840181905260009291820190839060c08601905b80831015610ed05783518252928401926001929092019190840190610eb0565b509695505050505050565b6040516080810167ffffffffffffffff81118282101715610efe57610efe610f47565b60405290565b604051601f8201601f1916810167ffffffffffffffff81118282101715610f2d57610f2d610f47565b604052919050565b6000610f413683610bd1565b92915050565b634e487b7160e01b600052604160045260246000fd5b8015158114610f6b57600080fd5b5056fea264697066735822122092b1c138fc934a18e9352683746aa9603d033896f9f8df858381f8e351ff2caf64736f6c63430008040033";
